import { useMediaProps } from '@zapier/responsive-utils';
import { Screen } from '@zapier/theme';

export const useSize = () => {
  const mediaProps = useMediaProps({
    all: {
      size: 'small',
    },
    [Screen.queries.tablet]: {
      size: 'medium',
    },
    [Screen.queries.desktop]: {
      size: 'large',
    },
  });

  return mediaProps?.size;
};
